
const devEnv = process.env.NODE_ENV !== "production"

export const host = `${devEnv ? "http://localhost:5000" : "https://quicktalk2-0.herokuapp.com"}`;
export const registerRoute = `${host}/api/auth/register`;
export const loginRoute = `${host}/api/auth/login`;
export const setAvatarRoute = `${host}/api/auth/setAvatar`;


export const allUsersRoute = `${host}/api/auth/allusers`;
export const sendMessageRoute = `${host}/api/messages/addmsg`;
export const getAllMessagesRoute = `${host}/api/messages/getmsg`;